import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar, Toolbar, useMediaQuery } from '@mui/material';

// project import
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContentEditor';

// assets
import React from 'react';
import SecondaryLogo from '../../../assets/main-logo/header-secondary-logo.png'
import { notify } from '../../../bmr/utils/methods/notification';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const HeaderEditor = ({ open }) => {

  const handleSetOpenLogoutSnackbarTrue = () => {
    notify.success("Logout successfully")
  }

  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

  // common header
  const mainHeader = (
    <Toolbar className='!pl-[15px]'>
      <img src={SecondaryLogo} width={"185px"} />
      <HeaderContent handleSetOpenLogoutSnackbarTrue={handleSetOpenLogoutSnackbarTrue} />
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      backgroundColor: '#171928'

    }
  };

  return (
    <>
      {!matchDownMD ? (
        <AppBarStyled open={open} {...appBar} className='border-b border-slate-600 z-[100]' sx={{ backgroundColor: '#171928', width: "100%", marginLeft: "0px !important",zIndex:1 }}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar sx={{ backgroundColor: "black" }} {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
};

HeaderEditor.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func
};

export default HeaderEditor;
